import React from 'react';
import { notEmpty } from 'utils/ramdaAdditions';
import { pathOr } from 'ramda';
import Translate from 'react-translate-component';
import { Tabs } from 'antd';
import DocumentList from 'components/common/fields/DocumentList';
import PersonWorking from './tabs/PersonWorking';
import PersonGeneral from './tabs/PersonGeneral';
import { DocumentTabHeader } from 'components/common/fields/DocumentTabHeader';

export default function PersonCard ({ meta, person }) {
    const docsCount = pathOr(0, ['documents', 'length'], person);

    const generalTabHeader = <Translate content="common.general" component="span" />;
    const workingTabHeader = <Translate content="person.working" component="span" />;
    const documentTabHeader = <DocumentTabHeader docsCount={ docsCount } />;

    return notEmpty(person) && (
        <Tabs defaultActiveKey="general" className="ant-tabs-triple">
            <Tabs.TabPane key="general" tab={generalTabHeader}>
                { meta.success && <PersonGeneral person={ person }/> }
            </Tabs.TabPane>
            <Tabs.TabPane key="working" tab={workingTabHeader}>
                { meta.success && <PersonWorking person={ person }/> }
            </Tabs.TabPane>
            <Tabs.TabPane key="documents" tab={ documentTabHeader } >
                { meta.success && <DocumentList documents={ person.documents }/> }
            </Tabs.TabPane>
        </Tabs>
    );
}
